<template>
    <p class="text-center text-gray-500 text-xs">
        &copy;2021 
        <a href="https://gacem.netlify.app/" target="_blank">Jervi</a> 
        of 
        <a href="https://gacem.netlify.app/" target="_blank">2Ks</a>  
        . All rights reserved.
    </p>
  
</template>

<script>
export default {
    name: 'Footer'
}
</script>